import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_chauffage-pac/artifacts/kjcz0m09_ChatGPT%20Image%2011%20fe%CC%81vr.%202026%20a%CC%80%2019_18_47%20%281%29.png";

export default function FooterSection() {
  return (
    <footer data-testid="footer-section" className="bg-black text-white py-12">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="bg-white rounded-xl p-3 inline-block mb-4">
              <img src={LOGO_URL} alt="Alter Energies - Chauffagiste RGE Lot-et-Garonne" className="h-10 w-auto" />
            </div>
            <p className="text-sm text-gray-400 leading-relaxed max-w-xs">
              Votre expert en pompe à chaleur et climatisation en Lot-et-Garonne. Certifié RGE QualiPAC, 500+ installations.
            </p>
          </div>

          {/* Services */}
<div>
  <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider">Nos services</h4>
  <ul className="space-y-2 text-sm text-gray-400">
    <li><a href="/installation-pompe-a-chaleur-lot-et-garonne" className="hover:text-white transition-colors">Installation pompe à chaleur</a></li>
    <li>Remplacement chaudière fioul</li>
    <li>Installation chauffe-eau thermodynamique</li>
    <li>Installation climatisation réversible</li>
    <li>Climatisation mono-split & gainable</li>
  </ul>
</div>

          {/* Zone */}
          <div>
            <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider">Zone d'intervention</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="/installation-pompe-a-chaleur-lot-et-garonne" className="hover:text-[#6AB023] transition-colors font-medium text-gray-300">Lot-et-Garonne (47)</a></li>
              <li><a href="/installation-pompe-a-chaleur-villeneuve-sur-lot" className="hover:text-white transition-colors">Villeneuve-sur-Lot</a></li>
              <li><a href="/installation-pompe-a-chaleur-tonneins" className="hover:text-white transition-colors">Tonneins</a></li>
              <li><a href="/installation-pompe-a-chaleur-aiguillon" className="hover:text-white transition-colors">Aiguillon</a></li>
              <li><a href="/installation-pompe-a-chaleur-fumel" className="hover:text-white transition-colors">Fumel</a></li>
              <li><a href="/installation-pompe-a-chaleur-sainte-livrade-sur-lot" className="hover:text-white transition-colors">Sainte-Livrade-sur-Lot</a></li>
              <li><a href="/installation-pompe-a-chaleur-miramont-de-guyenne" className="hover:text-white transition-colors">Miramont-de-Guyenne</a></li>
              <li><a href="/installation-pompe-a-chaleur-lot-et-garonne" className="hover:text-[#6AB023] transition-colors text-gray-300">Toutes nos communes →</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-white mb-4 text-sm uppercase tracking-wider">Contact</h4>
            <div className="space-y-3">
              <a href="tel:0628514915" className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors" data-testid="footer-phone">
                <Phone className="w-4 h-4" />
                06 28 51 49 15
              </a>
              <a href="mailto:frs.delattre@gmail.com" className="flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors" data-testid="footer-email">
                <Mail className="w-4 h-4" />
                frs.delattre@gmail.com
              </a>
              <a href="https://maps.app.goo.gl/C8s7vSJPZ2sHXxe16" target="_blank" rel="noreferrer" className="flex items-start gap-2 text-sm text-gray-400 hover:text-white transition-colors">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>1899 Côte de Pinel Garrigou<br />47380 Pinel-Hauterive</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          {/* SEO local text */}
          <p className="text-xs text-gray-600 leading-relaxed mb-6 max-w-4xl">
            ALTER ENERGIES intervient pour l'installation de pompe à chaleur air/eau et air/air, chauffe-eau thermodynamique et climatisation réversible (mono-split, gainable) à Villeneuve-sur-Lot, Tonneins, Aiguillon, Sainte-Livrade-sur-Lot, Fumel, Casseneuil, Bias, Pujols, Penne-d'Agenais, Monflanquin, Miramont-de-Guyenne, Monsempron-Libos, Cancon, Castillonnès, Villeréal, Clairac, Damazan, Port-Sainte-Marie et dans tout le Lot-et-Garonne (47). Chauffagiste certifié RGE QualiPAC, éligible MaPrimeRénov' et aides CEE. Devis gratuit et intervention rapide.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-gray-500">
            <p>&copy; {new Date().getFullYear()} ALTER ENERGIES. Tous droits réservés.</p>
            <div className="flex gap-6">
              <a href="/mentions-legales" className="hover:text-gray-300 cursor-pointer transition-colors">Mentions légales</a>
              <a href="/politique-de-confidentialite" className="hover:text-gray-300 cursor-pointer transition-colors">Politique de confidentialité</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
